import { useLocalObservable } from 'mobx-react-lite';

export const useHIState = () => {
  const state = useLocalObservable(() => ({
    contactName: '',
    contactEmail: '',
    ratio: '100%',
    requirements: '',
    title: '',
    setContactName(name) {
      state.contactName = name;
    },
    setTitle(title) {
      state.title = title;
    },
    setContactEmail(email) {
      state.contactEmail = email;
    },
    setRequirements(req) {
      state.requirements = req;
    },
    setRatio(rat) {
      if (!rat.match(/^\d{0,3}%?$/)) return;
      state.ratio = rat;
    },
    get form() {
      return {
        jobRatio: state.ratio.replace('%', ''),
        requirements: state.requirements,
        email: state.contactEmail,
        name: state.contactName,
        title: state.title,
      };
    },
    get disableSubmit() {
      if (!state.ratio || !state.contactName || !state.contactEmail) {
        return true;
      }
      return false;
    },
  }));

  return state;
};
